import React from "react";
import { toast } from "react-toastify";
import {
  Card,
  CardBody,
  Col,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";
import firebase from "../../config/firebase";
class Settings extends React.Component {
  state = {
    isOpen: false,
    dollar: "",
    cents: "",
    loading: false,
    data: undefined,
  };
  componentDidMount() {
    let arr = [];
    const db = firebase.firestore();
    const res = db
      .collection("settings")
      .doc("ammount")
      .get()
      .then((result) => {
        // console.log(result.data());return
        this.setState({ data: result.data() });
      })
      .catch((err) => console.log(err.message));
    // console.log(res)
  }
  onChangeHandler = (e) => this.setState({ [e.target.name]: e.target.value });
  toggle = () => {
    this.setState({ isOpen: !this.state.isOpen });
  };
  changePayment = async () => {
    this.setState({ loading: true });
    const { dollar,cents } = this.state;
    if(!dollar || !cents) {
      toast.error("Please FillAll Field")
      this.setState({ loading: false });
      return
    }
    if(cents.length<=1 || cents.length >2){
      toast.error("Cents must be in 2 digit")
      this.setState({ loading: false });
      return
    }
    try {
      let data = {
        date: new Date().toLocaleDateString(),
        dollar: parseInt(dollar),
        cents:cents
      };
      const db = firebase.firestore();
      const res = await db.collection("settings").doc("ammount").set(data);
      console.log(res);
      // res.then(res=>console.log(res))
      this.setState({ loading: false, data });
      this.toggle();
      toast.success("Successfully amount updated")

    } catch (err) {
      console.log(err.message);
      this.setState({ loading: false });
      this.toggle();
    }
  };
  render() {
    const { dollar, loading, isOpen, data, cents } = this.state;
    console.log(loading);
    return (
      <>
        <Col md={12}>
          <Card>
            <h3 style={{ marginBottom: "10px" }}>Settings</h3>
            <CardBody>
              <Col>
              <h2>Payment Section</h2>
                <Table>
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Current Ammount</th>
                      <th>Last Date Updated</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">1</th>
                      <td>${data?.dollar}.{data?.cents} </td>
                      <td> {data?.date} </td>
                      <td>
                        <Button color="success" size="sm" onClick={this.toggle}>
                          Change
                        </Button>
                      </td>
                    </tr>
                  </tbody>
                </Table>
                {/* <div className='form-inner' > */}
                <Modal isOpen={isOpen} toggle={this.toggle}>
                  <ModalHeader toggle={this.toggle}>
                    Change Job Ammount
                  </ModalHeader>
                  <ModalBody>
                    <label>
                      Enter Dollar <span style={{color:'red',marginTop:'-30px'}}>•</span>
                    </label>{" "}
                    <br />
                    <input
                      type="text"
                      name="dollar"
                      value={dollar}
                      onChange={this.onChangeHandler}
                      placeholder="50"
                    />
                    <br />
                    <br />
                    <label>
                      Enter Cents <span style={{color:'red',marginTop:'-30px'}}>•</span>
                    </label>{" "}
                    <br />
                    <input
                      type="text"
                      name="cents"
                      value={cents}
                      onChange={this.onChangeHandler}
                      placeholder="50"
                    />
                    <p>Example: “00”. Cents must be in 2 digits.</p>
                  </ModalBody>
                  <ModalFooter>
                    <Button
                      color="danger"
                      onClick={this.changePayment}
                      size="sm"
                      disabled={loading}
                    >
                      {loading ? "loading..." : "update"}
                    </Button>{" "}
                    <Button
                      color="secondary"
                      onClick={this.toggle}
                      size="sm"
                      disabled={loading}
                    >
                      Cancel
                    </Button>
                  </ModalFooter>
                </Modal>

                {/* </div> */}
              </Col>
            </CardBody>
          </Card>
        </Col>
      </>
    );
  }
}

export default Settings;
